export const resumeImportUploadRules = {
    fileFormats: ['application/pdf', 'image/png', 'image/jpeg'],
    maxFileSize: 5,
};
